export default function getImage(src) {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.src = `${src}?timestamp=${new Date().getTime()}`
    image.onload = () => resolve(image)
    image.onerror = reject
  })
}
